// TODO: Temporary solution while AWF investigates BFF change
import { Injectable } from "@angular/core";
import {
  GetAssignedEntitlementsGQL,
  GetPreviewEntitlementsGQL,
  GetAssignedUserCountsGQL,
  GetActiveUserAssignmentsGQL,
  GetAssignedEntitlementsQuery_getAssignedEntitlements_EntitlementPaginationResult_data_Entitlement,
  GetActiveUserAssignmentsQuery_getActiveUserAssignments_AssignedEntitlement,
  GetAssignedEntitlementsQuery_getAssignedEntitlements_EntitlementPaginationResult,
  GetPreviewEntitlementsQuery_getPreviewEntitlements_EntitlementPaginationResult,
  GetAssignedUserCountsQuery_getAssignedUserCounts_AssignedUserCountPaginationResult
} from "@ansys-internal/portal-bff-angular-client";
import { Observable, map, of } from "rxjs";
import { AWFActiveUserAssignments, AWFAssignedEntitlementsPaginationResult, AWFAssignedUserCounts, AWFAssignedUserCountsPaginationResult, AWFProduct, AWFProductsDataProvider, AWFUserProducts } from "@ansys-internal/awf-angular/shared";
@Injectable({
  providedIn: 'root',
})
export class ProductDataDefaultProvider implements AWFProductsDataProvider {
  constructor(
    private getAssignedEntitlementsGQL: GetAssignedEntitlementsGQL,
    private getPreviewEntitlementsGQL: GetPreviewEntitlementsGQL,
    private getAssignedUserCountsGQL: GetAssignedUserCountsGQL,
    private getActiveUserAssignmentsGQL: GetActiveUserAssignmentsGQL,
  ) {}

  /**
   *
   * Only returns up to 1000 assigned entitlements. Consider using getAssignedEntitlementsSteam and getPreviewEntitlementsStream for modern
   * calls that include pagination.
   * @param accountId
   * @param pageNumber
   * @param pageSize
   * @returns
   */
  getProductsStream(accountId: string, pageNumber: number = 0, pageSize: number = 1000): Observable<GetAssignedEntitlementsQuery_getAssignedEntitlements_EntitlementPaginationResult_data_Entitlement[] > {
    return this.getAssignedEntitlementsGQL.fetch({ variables: { accountId, pageNumber, pageSize } }).pipe(map((res: any) => {
      return res?.data.getAssignedEntitlements.data || [];
    }));
  }

  convertProductPageStream(input: GetAssignedEntitlementsQuery_getAssignedEntitlements_EntitlementPaginationResult_data_Entitlement[]): AWFUserProducts {
    return {
      assignedProducts: (input as AWFProduct[] || []).map((item) => {
        return { ...item, productName: item.name || '' }
      }),
      previewProducts: [],
      utilityProducts: [],
    } as AWFUserProducts;
  }

  getAssignedEntitlementsStream(accountId: string, pageNumber: number = 0, pageSize: number = 1000): Observable<GetAssignedEntitlementsQuery_getAssignedEntitlements_EntitlementPaginationResult> {
    return this.getAssignedEntitlementsGQL.fetch({ variables: { accountId, pageNumber, pageSize } }).pipe(map((res: any) => {
      return {
        data: res?.data || [],
        pagination: res.pagination
      };
    }));
  }

  convertAssignedEntitlementsStream(input: GetAssignedEntitlementsQuery_getAssignedEntitlements_EntitlementPaginationResult): AWFAssignedEntitlementsPaginationResult {
    return input as AWFAssignedEntitlementsPaginationResult;
  }

  getPreviewEntitlementsStream(accountId: string, pageNumber: number = 0, pageSize: number = 1000): Observable<GetPreviewEntitlementsQuery_getPreviewEntitlements_EntitlementPaginationResult> {
    return this.getPreviewEntitlementsGQL.fetch({ variables: { accountId, pageNumber, pageSize } }).pipe(map((res: any) => {
      return {
        data: res?.data || [],
        pagination: res.pagination
      };
    }));
  }

  convertPreviewEntitlementsStream(input: GetPreviewEntitlementsQuery_getPreviewEntitlements_EntitlementPaginationResult): AWFAssignedEntitlementsPaginationResult {
    return input as AWFAssignedEntitlementsPaginationResult;
  }

  getAssignedUserCountsStream(accountId: string, pageNumber: number = 0, pageSize: number = 1000): Observable<GetAssignedUserCountsQuery_getAssignedUserCounts_AssignedUserCountPaginationResult> {
    return this.getAssignedUserCountsGQL.fetch({ variables: { accountId, pageNumber, pageSize } }).pipe(map((res: any) => {
      return {
        data: res?.data || [],
        pagination: res.pagination
      };
    }));
  }

  convertAssignedUserCountsStream(input: GetAssignedUserCountsQuery_getAssignedUserCounts_AssignedUserCountPaginationResult): AWFAssignedUserCountsPaginationResult {
    return input as AWFAssignedUserCountsPaginationResult;
  }

  getActiveUserAssignmentStream(accountId: string): Observable<GetActiveUserAssignmentsQuery_getActiveUserAssignments_AssignedEntitlement[]> {
    return this.getActiveUserAssignmentsGQL.fetch({ variables: { accountId } }).pipe(map((res: any) => {
      return res?.data || [];
    }));
  }

  convertActiveUserAssignmentStream(input: GetActiveUserAssignmentsQuery_getActiveUserAssignments_AssignedEntitlement[]): AWFActiveUserAssignments[] {
    return input as AWFActiveUserAssignments[];
  }
}

